export const PUBLIC_QUEUE_RAMP_KEY = 'coreweave_evals_public_queue';
export const WANDB_ENTITY_NAME = 'wandb';
export const WANDB_JOBS_PROJECT_NAME = 'jobs';
export const WANDB_PUBLIC_QUEUE_NAME = 'CoreWeave';

export const TEST_PUBLIC_QUEUE_NAME = 'Test Public Queue';
export const TEST_PUBLIC_QUEUE_ACCESS_ENTITY = 'launch-team-qa';
export const TEST_PUBLIC_QUEUE_ENTITY = 'wandb';
export const TEST_JOBS_PROJECT_NAME = 'test-jobs';
